import React from 'react';
import StyleColourPicker from "./StyleColourPicker";
import { getDefaultColour } from "./ManageColours";

const BasicTableStyles = props => {
    const { styles = {}, updateStylesCallback } = props;

    const defaultTableColour = getDefaultColour('--cont-table-custom-colour', styles);

    return (
        <>
            <h4 className="margin-t--m">Table Styles</h4>

            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">Table color</div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={defaultTableColour}
                        onChange={(colour) => updateStylesCallback({
                            [`--cont-table-custom-colour`]: colour.hex(),
                            [`--cont-table-custom-colour-RGB`]: colour.rgb().array()
                        })}
                    />
                </div>
            </div>
        </>
    );
};

export default BasicTableStyles;
